import type { TranscriptFragment } from "@repo/app-types/client/client";
import type { Contact } from "@repo/app-types/entities/contact";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { ContactNameWithTime } from "./contactNameWithTime.js";
import { TranscriptFragmentText } from "./transcriptFragmentText.js";

interface ContactNameWithTranscriptFragmentProps {
  contact: Contact;
  date?: Date;
  transcriptFragments: TranscriptFragment[];
  shouldHideQuestion?: boolean;
  onClick: () => void;
  classNames?: string;
}

export const ContactNameWithTranscriptFragment: FC<
  ContactNameWithTranscriptFragmentProps
> = ({
  contact,
  date,
  transcriptFragments,
  onClick,
  classNames,
  shouldHideQuestion,
}) => {
  return (
    <div
      className={twMerge(
        "flex cursor-pointer flex-col rounded-md ring-1 ring-gray-100",
        classNames,
      )}
      onClick={onClick}
    >
      <div className="border-b border-gray-100 px-3 py-2">
        <ContactNameWithTime contact={contact} date={date} />
      </div>
      <div className={twMerge(!shouldHideQuestion && "p-3")}>
        {transcriptFragments.map((t, i) => {
          return (
            <div
              key={`contact-name-with-fragment-${t.id}`}
              className={twMerge(
                "text-sm text-foreground",
                t.is_dynamic_question && !shouldHideQuestion && "pl-6",
              )}
            >
              {shouldHideQuestion ? null : (
                <div
                  className={twMerge("mb-2 text-foreground", i !== 0 && "mt-2")}
                >
                  {t.question}
                </div>
              )}
              <TranscriptFragmentText text={t.text_transcript} role={t.role} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
